module.exports = __webpack_public_path__ + "static/img/circle-4.b16c786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/circle-4.png
// module id = xkyy
// module chunks = 0